import React from "react";
import DownloadIcon from "../trendPage/commonComponent/downloadIcon";
import { Button } from "@mui/material";

export const DashboardCSVDownload = () => {
  const getAllCSVDownloadButton = () => {
    const buttons = document.getElementsByName("csvDownloadButton");
    buttons.forEach((button) => {
      button.click();
    });
  };

  return (
    <Button
      sx={{ width: "25px", height: "25px", padding: "0px 0px", minWidth: "0px", margin: "0 10px" }}
      onClick={() => getAllCSVDownloadButton()}
    >
      <DownloadIcon color={"#D8D8D8"} opacity={"1"} />
    </Button>
  );
};
